import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import ReactSelect from 'react-select';

const AssingClass = (props) => {
  const { data, closeModal ,assingClassRoom } = props;
  const { classRoomsList } = useSelector((state) => state.student);
  const [show, setShow] = useState(props.show);
  const validationSchema = Yup.object().shape({
    ClassRoomId: Yup.object().nullable().required("ClassRoom Name is required"),
  });

  useEffect(() => {
    setShow(props.show);
    reset();
  }, [props.show]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleClose = () => {
    setShow(false);
    closeModal();
  };
  const handleShow = () => setShow(true);
  const onSubmit = async(data)=>{
    await assingClassRoom({
      ClassRoomId : data.ClassRoomId.value,
      BranchClassGroupClassRoomId: data.ClassRoomId.id,
      classRoomName : data.ClassRoomId.label
    })
    closeModal();
  }
  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign ClassRoom</Modal.Title>
        </Modal.Header>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group
            as={Row}
            className="mb-3 required"
            controlId="formPlaintextEmail"
          >
            <Form.Label column sm="4">
              Class Name
            </Form.Label>
            <Col sm="4">
            <Controller
                  name="ClassRoomId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={classRoomsList}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
              {/* <Form.Control
                as="select"
                name="classRoomName"
                //   defaultValue={this.props.inputValues.state}
                //   onChange={this.props.handleChange}
                className={`form-control ${
                  errors.ClassRoomId ? "is-invalid" : ""
                }`}
                {...register("ClassRoomId")}
              >
                <option value="">Please Select</option>
                {classRoomsList.map((obj) => (
                  <option value={obj.id}>{obj.name}</option>
                ))}
              </Form.Control>
              <span className="invalid-feedback">
                {errors.ClassRoomId?.message}
              </span> */}
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary app-default-button" type="submit">
            Add ClassRoom
          </Button>
        </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default AssingClass;
